// extracted by css-extract-rspack-plugin
export default {"cls1":"SimplePaperPodcast-cls1_uby","cls2":"SimplePaperPodcast-cls2_2Ee SimplePaperPodcast-cls1_uby"};